import { render } from "./SentBackReason.vue?vue&type=template&id=2667a374"
import script from "./SentBackReason.vue?vue&type=script&lang=js"
export * from "./SentBackReason.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__